import { combineReducers } from "redux";
import videoReducer from "./video/video-reducer";
import homeReducer from "./home/home-reducer";
import { exploreReducer } from "./explore/explore-reducer";
import { applicationReducer } from "./application/application-reducer";
import { collectionsReducer } from "./collections/collections-reducer";
import { tagsReducer } from "./tags/tags-reducer";
import { nichesReducer } from "./niches/niches-reducer";
import userReducer from "./user/user-reducer";
import searchReducer from "./search/search-reducer";

const reducers = {
  application: applicationReducer,
  collections: collectionsReducer,
  explore: exploreReducer,
  home: homeReducer,
  niches: nichesReducer,
  tags: tagsReducer,
  user: userReducer,
  video: videoReducer,
  search: searchReducer
};

// const appSettingsConfig = {
//   key: "appSettings",
//   storage,
//   // blacklist: ['some names']
// }

const appReducer = combineReducers({
  ...reducers,
  // video: persistReducer(appSettingsConfig, reducers.video)
});

export const rootReducer = (state: any, action: any) => {
  return appReducer(state, action);
};
